module.exports = __webpack_public_path__ + "img/stop_square.d5769089.svg";